// extracted by mini-css-extract-plugin
export default {"root":"style_root__V0XAI","content":"style_content__3t0jY","heading":"style_heading__jNpZ-"};